// extracted by mini-css-extract-plugin
module.exports = {"locl-quick-search":"quick-search_locl-quick-search__0C1yk"};